const SOCKET_EVENT_NAME = 'app:socket_message';

export const eventBus = {
  emit<T>(data: T): void {
    const event = new CustomEvent(SOCKET_EVENT_NAME, { detail: data });

    dispatchEvent(event);
  },

  subscribe<T>(callback: (data: T) => void): () => void {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent;

      callback(customEvent.detail);
    };

    addEventListener(SOCKET_EVENT_NAME, handler);

    return () => removeEventListener(SOCKET_EVENT_NAME, handler);
  },
};
